import { render } from "./RegistrationsList.vue?vue&type=template&id=ee9cd748&scoped=true"
import script from "./RegistrationsList.vue?vue&type=script&lang=js"
export * from "./RegistrationsList.vue?vue&type=script&lang=js"

import "./RegistrationsList.vue?vue&type=style&index=0&id=ee9cd748&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee9cd748"]])

export default __exports__